import { TipoConsumoModel } from './tipoconsumo.model';

export class PedidoModel {
    tipoconsumo: TipoConsumoModel[] = [];
}
